import { Alert, Grid, Link, Typography } from "@mui/material";
import { FC, useState } from "react";
import AddressForm from "../../../../../components/address/AddressForm";
import { Address } from "../../../../../model/Address";
import { AddressFormElement, TaskExecutionState } from "../../../types";

type TaskFormAddressType = {
  //formId?: string;
  disabled: boolean;
  onValueChange: (value: Address) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  execution: any;
  //formExecutionComponentProps: FormExecutionComponentProps;
} & AddressFormElement;
const TaskFormAddressComponent: FC<TaskFormAddressType> = ({
  onValueChange,
  taskExecutionState,
  ...props
}) => {
  const [insufficient, setInsufficient] = useState(false);
  const [condensedOverride, setCondensedOverride] = useState<
    boolean | undefined
  >(undefined);
  const addressAsString = (address: Address) => {
    if (!address) return "";
    if (
      address.city == "" ||
      address.first_line == "" ||
      address.state == "" ||
      address.zip_code == 0
    )
      return "";

    const secondLine =
      address.second_line && address.second_line !== ""
        ? ` ${address.second_line},`
        : "";

    return `${address.first_line},${secondLine} ${address.city}, ${address.state} ${address.zip_code}`;
  };

  if (props.disabled && taskExecutionState === TaskExecutionState.Completed) {
    const address = (props.execution?.value as Address) ?? undefined;
    return (
      <Grid item container gap={1} alignItems={"center"}>
        <Typography variant="subtitle1">{props.label}:</Typography>
        <Typography>{addressAsString(address)}</Typography>
      </Grid>
    );
  }

  return (
    <Grid container spacing={0} direction={"row"} width={"100%"}>
      {props.manual && (
        <Grid item xs={12}>
          <Typography px={"2px"} my={0}>
            {props.label}
          </Typography>
        </Grid>
      )}
      <Grid item mt={1} xs={12}>
        <AddressForm
          noControls
          disabled={props.disabled}
          current={props.execution?.value as Address}
          strict={props.strict}
          required={props.required || false}
          condensed={condensedOverride ?? props.condensed}
          manual={condensedOverride === undefined ? props.manual : true}
          canExpand={condensedOverride ?? props.canExpand}
          autocompleteLabel={props.label}
          onInsufficient={() => {
            setInsufficient(true);
          }}
          onChange={(val) => {
            if (val) setInsufficient(false);
            onValueChange(val);
          }}
        />
      </Grid>
      {insufficient && (
        <Grid item xs={12} mt={1}>
          <Alert severity="warning">
            {`It seems like we couldn't get all the information we needed for that address.`}{" "}
            <Link onClick={() => setCondensedOverride(false)}>
              {`Please try entering it manually.`}
            </Link>
          </Alert>
        </Grid>
      )}
    </Grid>
  );
};

export default TaskFormAddressComponent;
